import moment from 'moment'
import client from '../../apollo'
import loSto from '../../config/loSto'
import { SendLogToServer } from '@sukiai/gql/common'
import { LO_STO } from '../constants'

// Log level constants
const DEBUG = 'DEBUG'
const ERROR = 'ERROR'
const INFO = 'INFO'
const LOG = 'LOG'
const WARN = 'WARN'

// USER role
const USER = 'USER'

// Send log to the ui/api backend server
const sendLog = ({
  message,
  level
}) => {
  const sessionToken = loSto.get(LO_STO.SESSION_ID)
  const user = loSto.get(LO_STO.USER_ID)
  if (sessionToken && user) {
    client.mutate({
      mutation: SendLogToServer,
      variables: {
        session: sessionToken,
        role: USER,
        user,
        ua: window.navigator && window.navigator.userAgent,
        message: [message], // backend parses this array of messages
        level,
        timestamp: moment().toISOString()
      }
    })
  }
}

class Logger {
  debug = (message) => {
    sendLog({
      message,
      level: DEBUG
    })
  }

  error = (message) => {
    sendLog({
      message,
      level: ERROR
    })
  }

  info = (message) => {
    sendLog({
      message,
      level: INFO
    })
  }

  log = (message) => {
    sendLog({
      message,
      level: LOG
    })
  }

  warn = (message) => {
    sendLog({
      message,
      level: WARN
    })
  }
}

// One instance for the entire app
const singletonLogger = new Logger()

export default singletonLogger
